<template>
  <div class="success-page">
    <CContainer class="d-flex justify-content-center align-items-center min-vh-100">
      <CCard class="text-center shadow-lg p-4" style="max-width: 500px; width: 100%;">
        <CCardBody>
          <div class="mb-3">
            <CIcon name="cil-check-circle" class="text-success" />
          </div>

          <!-- Translated Content -->
          <h3 class="mb-2 text-success">
            {{ language === 'en' ? 'Success' : 'สำเร็จ' }}
          </h3>
          <p class="text-muted">
            {{ language === 'en'
              ? 'The operation was completed successfully.'
              : 'ดำเนินการเสร็จสิ้นเรียบร้อยแล้ว' }}
          </p>
          <p class="text-muted">
            {{ language === 'en'
              ? 'Refresh Page to Continue'
              : 'กรุณารีเฟรชหน้าบราวเซอร์' }}
          </p>

          <!-- One Toggle Button -->
          <div class="mt-4">
            <CButton color="light" @click="toggleLanguage">
              {{ language === 'en' ? 'ไทย' : 'EN' }}
            </CButton>
          </div>
        </CCardBody>
      </CCard>
    </CContainer>
  </div>
</template>

<script>
import { CIcon } from '@coreui/icons-vue'
import { CButton } from '@coreui/vue'

export default {
  name: 'LoginSuccess',
  components: {
    CIcon,
    CButton,
  },
  data() {
    return {
      language: 'en', // default
    }
  },
  methods: {
    toggleLanguage() {
      this.language = this.language === 'en' ? 'th' : 'en'
    },
    refreshPage() {
      window.location.reload()
    },
  },
}
</script>

<style scoped>
.success-page {
  background-color: #f8f9fa;
}

.text-success {
  color: #2eb85c !important;
}

.shadow-lg {
  box-shadow: 0 0.5rem 1.5rem rgba(0, 0, 0, 0.1) !important;
}
</style>